import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data
const UPDATED_EVENT = 'preika:project-notification-updated'

function notifyUpdated (projectId, source) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return
  const detail = {
    project_id: Number(projectId),
    source
  }
  if (typeof window.CustomEvent === 'function') {
    window.dispatchEvent(new window.CustomEvent(UPDATED_EVENT, { detail }))
    return
  }
  const event = document.createEvent('CustomEvent')
  event.initCustomEvent(UPDATED_EVENT, false, false, detail)
  window.dispatchEvent(event)
}

export { UPDATED_EVENT }

export default {
  get (projectId) {
    return axios
      .get(`${origin}/project-notifications/${projectId}`)
      .then(responseData)
  },
  update (projectId, payload) {
    return axios
      .post(`${origin}/project-notifications/${projectId}`, payload)
      .then(response => {
        const data = responseData(response)
        notifyUpdated(projectId, 'leave')
        return data
      })
  },
  test (projectId, payload) {
    return axios
      .post(`${origin}/project-notifications/${projectId}/test`, payload)
      .then(responseData)
  }
}
